import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Annuler',
    connectionAttempt: 'Connection attempt',
    device: 'Device',
    location: 'Location',
    unblockThisDevice: 'Unblock this device',
    unblockThisDeviceSubtitle:
      'You will be able to connect to your Shine account with this device again by approving the connection from an already authorized device.',
    unblockThisDeviceTitle: 'Do you want to unblock this device?',
    unknownDeviceType: 'Unknown device type',
  },
  fr: {
    cancel: 'Annuler',
    connectionAttempt: 'Tentative de connexion',
    device: 'Appareil',
    location: 'Lieu',
    unblockThisDevice: 'Débloquer cet appareil',
    unblockThisDeviceSubtitle:
      'Vous pourrez de nouveau vous connecter à cet appareil en validant la connexion depuis un appareil déjà autorisé.',
    unblockThisDeviceTitle: 'Voulez-vous débloquer cet appareil ?',
    unknownDeviceType: 'Type d’appareil inconnu',
  },
});

export default locales;
